(() => {
  const drawer = document.querySelector('#drawer');
  const menuButton = document.querySelector('#menuButton');
  const scrim = document.querySelector('#scrim');
  const closeButton = document.querySelector('#drawerClose');
  function toggleMenu(open) {
    if (!drawer || !scrim || !menuButton) return;
    drawer.classList.toggle('open', open);
    scrim.classList.toggle('open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    menuButton.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('locked', open);
  }
  menuButton?.addEventListener('click', () => toggleMenu(true));
  closeButton?.addEventListener('click', () => toggleMenu(false));
  scrim?.addEventListener('click', () => toggleMenu(false));
  drawer?.querySelectorAll('a').forEach(link => link.addEventListener('click', () => toggleMenu(false)));

  const searchPanel = document.querySelector('#searchPanel');
  document.querySelector('#searchButton')?.addEventListener('click', () => {
    if (!searchPanel) return;
    searchPanel.hidden = !searchPanel.hidden;
    if (!searchPanel.hidden) document.querySelector('#searchInput')?.focus();
  });

  const meter = document.querySelector('.shipping-meter');
  const progress = document.querySelector('#shippingProgress');
  if (meter && progress) {
    const total = Number(meter.dataset.cartTotal || 0);
    const goal = Number(meter.dataset.freeShipping || 75);
    progress.style.width = `${Math.max(4, Math.min(100, total / goal * 100))}%`;
    progress.className = total >= goal ? 'shipping-green' : total >= goal * .47 ? 'shipping-yellow' : 'shipping-red';
  }

  const carousel = document.querySelector('#carousel');
  if (carousel) {
    const cards = [...carousel.querySelectorAll('figure')];
    const dots = document.querySelector('#dots');
    const counter = document.querySelector('#counter');
    cards.forEach((_, index) => { const dot = document.createElement('span'); if (!index) dot.className = 'active'; dots?.append(dot); });
    const dotEls = [...(dots?.children || [])];
    const step = () => (cards[0]?.getBoundingClientRect().width || 0) + 14;
    const move = direction => carousel.scrollBy({ left: direction * step(), behavior: 'smooth' });
    document.querySelector('#prev')?.addEventListener('click', () => move(-1));
    document.querySelector('#next')?.addEventListener('click', () => move(1));
    const update = () => {
      const index = Math.max(0, Math.min(cards.length - 1, Math.round(carousel.scrollLeft / Math.max(step(), 1))));
      if (counter) counter.textContent = `${index + 1} / ${cards.length}`;
      dotEls.forEach((dot, i) => dot.classList.toggle('active', i === index));
    };
    carousel.addEventListener('scroll', update, { passive: true });
    carousel.addEventListener('keydown', event => { if (event.key === 'ArrowRight') move(1); if (event.key === 'ArrowLeft') move(-1); });
  }

  const fitDialog = document.querySelector('#fitDialog');
  document.querySelector('#fitButton')?.addEventListener('click', () => fitDialog?.showModal());
  document.querySelector('#fitClose')?.addEventListener('click', () => fitDialog?.close());
  const fitForm = document.querySelector('#fitForm');
  fitForm?.addEventListener('submit', event => {
    event.preventDefault();
    const feet = Number(document.querySelector('#heightFeet')?.value);
    const inches = Number(document.querySelector('#heightInches')?.value);
    const weight = Number(document.querySelector('#weight')?.value);
    const preference = Number(document.querySelector('#fitPreference')?.value || 0);
    if (!weight || !feet || inches < 0 || inches > 11) return;
    let index = weight < 135 ? 0 : weight < 165 ? 1 : weight < 205 ? 2 : 3;
    if (feet * 12 + inches >= 75) index++;
    index = Math.max(0, Math.min(3, index + preference));
    const size = ['S', 'M', 'L', 'XL'][index];
    const result = document.querySelector('#fitResult');
    if (!result) return;
    result.innerHTML = `YOUR STARTING SIZE<strong>${size}</strong><button type="button" class="use-size" data-size="${size}">SHOP SIZE ${size}</button>`;
    result.hidden = false;
  });
  document.querySelector('#fitResult')?.addEventListener('click', event => {
    const button = event.target.closest('.use-size');
    if (!button) return;
    fitDialog?.close();
    const shopLink = document.querySelector('#quickShop');
    const target = shopLink?.dataset.shopUrl || '/collections/all';
    const url = new URL(target, window.location.origin);
    if (shopLink?.dataset.productSelected === 'true') url.searchParams.set('size', button.dataset.size);
    window.location.assign(url.toString());
  });

  const stickyShop = document.querySelector('#stickyShop');
  const bottoms = document.querySelector('#bottoms');
  if (stickyShop && bottoms && 'IntersectionObserver' in window) {
    new IntersectionObserver(entries => stickyShop.classList.toggle('visible', !entries[0].isIntersecting), { threshold: .2 }).observe(bottoms);
  }
  const quickSize = document.querySelector('#quickSize');
  const quickShop = document.querySelector('#quickShop');
  quickSize?.addEventListener('change', () => {
    if (quickShop) quickShop.textContent = quickSize.value ? `SHOP SIZE ${quickSize.value}` : 'SHOP SHORTS';
  });
  quickShop?.addEventListener('click', event => {
    if (!quickSize) return;
    event.preventDefault();
    const url = new URL(quickShop.dataset.shopUrl || quickShop.href, window.location.origin);
    if (quickSize.value && quickShop.dataset.productSelected === 'true') url.searchParams.set('size', quickSize.value);
    window.location.assign(url.toString());
  });

  const reviewRail = document.querySelector('#reviewRail');
  if (reviewRail) {
    const cards = [...reviewRail.querySelectorAll('.review-card')];
    const counter = document.querySelector('#reviewCounter');
    const step = () => (cards[0]?.getBoundingClientRect().width || 0) + 16;
    const move = direction => reviewRail.scrollBy({ left: direction * step(), behavior: 'smooth' });
    document.querySelector('#reviewPrev')?.addEventListener('click', () => move(-1));
    document.querySelector('#reviewNext')?.addEventListener('click', () => move(1));
    reviewRail.addEventListener('scroll', () => {
      const index = Math.max(0, Math.min(cards.length - 1, Math.round(reviewRail.scrollLeft / Math.max(step(), 1))));
      if (counter) counter.textContent = `${String(index + 1).padStart(2, '0')} / ${cards.length}`;
    }, { passive: true });
    reviewRail.addEventListener('keydown', event => { if (event.key === 'ArrowRight') move(1); if (event.key === 'ArrowLeft') move(-1); });
  }

  document.querySelectorAll('[data-variant-option]').forEach(button => button.addEventListener('click', () => {
    const form = button.closest('[data-product-form]');
    const select = form?.querySelector('select[name="id"]');
    if (!select) return;
    select.value = button.dataset.variantId;
    form.querySelectorAll('[data-variant-option]').forEach(option => option.setAttribute('aria-pressed', String(option === button)));
    const submit = form.querySelector('[type="submit"]');
    if (submit) { submit.disabled = button.disabled; submit.textContent = button.disabled ? 'SOLD OUT' : 'ADD TO BAG — $35'; }
    const price = document.querySelector('#ProductPrice');
    if (price) price.textContent = button.dataset.displayPrice || '$35.00 USD';
  }));
  const collectionSize = new URLSearchParams(window.location.search).get('size');
  if (collectionSize) document.querySelectorAll('[data-product-link]').forEach(link => {
    const url = new URL(link.href);
    url.searchParams.set('size', collectionSize);
    link.href = url.toString();
  });
  document.querySelectorAll('[data-product-form]').forEach(form => {
    const wanted = new URLSearchParams(window.location.search).get('size');
    const option = [...form.querySelectorAll('[data-variant-option]')].find(button => wanted && button.textContent.trim().toUpperCase().startsWith(wanted.toUpperCase()) && !button.disabled);
    option?.click();
  });
  document.querySelectorAll('[data-image-src]').forEach(button => button.addEventListener('click', () => {
    const hero = document.querySelector('#productHero');
    if (hero) hero.src = button.dataset.imageSrc;
    document.querySelectorAll('[data-image-src]').forEach(thumb => thumb.setAttribute('aria-current', String(thumb === button)));
  }));
})();
